<template>
<div>

    <p>Specify which companies will use this plan and the plan/account number with the provider.</p>

    <table class="table pt-4">
        <tbody>
        <tr>
            <th>Company</th>
            <th>Enabled</th>
            <th>Plan number</th>
        </tr>

        <tr v-for="company in client.companies">
            <td>{{ company.name }}</td>
            <td><form-input label="" v-model="formData.companies_enabled[company.id]" type="checkbox" :form-check-inline="true" @update:modelValue="toggleCompany(company.id)" /></td>
            <td><form-input label="" v-model="formData['plan_number_' + company.id]" :errors="errors['plan_number_' + company.id]" type="text" maxlength="64" :disabled="!formData.companies_enabled[company.id]" /></td>
        </tr>
        </tbody>
    </table>
</div>
</template>

<script>
import moment from 'moment'
import FormMixin from '@/mixins/Form'

function formatAsCurrency(val) {
    val = ('' + val).trim()

    val = (1 * val).toFixed(2)
    if (val.split('.').length < 2) {
        val = val + '.00'
    }
    if (val.split('.')[1].length < 2) {
        val = val + '0'
    }
    return val
}

export default {
    props: ['initialValue', 'client'],
    mixins: [FormMixin],
    data() {
        return {
            formData: this.makeFormData(),
            errors: {},
        }
    },
    methods: {
        validate() {
            this.errors = {}
            this.formErrors = []
            const originalValidate = FormMixin.methods.validate.bind(this)
            let isValid = originalValidate()

            if (this.client.companies.filter(c => this.formData.companies_enabled[c.id]).length < 1) {
                this.formErrors.push('Enable this plan for at least one company.')
                isValid = false
            }

            return isValid
        },
        getFormLabels() {
            const result = {}

            this.client.companies.forEach(c => {
                result['plan_number_' + c.id] = 'Plan number'
            })

            return result
        },
        getFormRules() {
            const result = {}

            this.client.companies.forEach(c => {
                if (this.formData.companies_enabled[c.id]) {
                    result['plan_number_' + c.id] = {presence: {allowEmpty: false}}
                }
            })

            return result
        },
        makeFormData() {
            const result = {
                companies_enabled: {},
            }

            this.client.companies.forEach(c => {
                result.companies_enabled[c.id] = this.initialValue[c.id] ? true : false
                result['plan_number_' + c.id] = this.initialValue[c.id] ? this.initialValue[c.id] : ''
            })

            return result
        },
        getPlanNumbers() {
            const result = {}

            this.client.companies.forEach(c => {
                if (this.formData.companies_enabled[c.id]) {
                    result[c.id] = this.formData['plan_number_' + c.id]
                }
            })

            return result
        },
        toggleCompany(companyId) {
            if (this.formData.companies_enabled[companyId]) {
                // pass
            }
            else {
                this.formData['plan_number_' + companyId] = ''
            }

        },
    },
}
</script>
